export const AlertsActionTypes = {
  SET_DIAGNOSTIC_ALERTS: 'SET_DIAGNOSTIC_ALERTS',
  SET_DOMAINS_PROPAGATION: 'SET_DOMAINS_PROPAGATION',
  SET_TICKETS_ALERTS: 'SET_TICKETS_ALERTS',
  ADD_NEW_DIAGNOSTIC_ALERT: 'ADD_NEW_DIAGNOSTIC_ALERT',
  CLICK_ON_ALERT_DOMAIN_TO_POINT: 'CLICK_ON_ALERT_DOMAIN_TO_POINT',
};
